import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentSchool: null,
};

export const schoolSlice = createSlice({
  name: "school",
  initialState,

  reducers: {
    setSchool: (state, action) => {
      state.currentSchool = action.payload;
    },
    removeSchool: (state) => {
      state.currentSchool = null;
    },
  },
});

export const { setSchool, removeSchool } =
  schoolSlice.actions;

export default schoolSlice.reducer;
